<template>
  <div class="parking-space-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
            <div class="ibox-tools">
              <el-button type="text" @click="toggleMoreCondition">
                {{ listParkingSpaceInfo.moreCondition ? "隐藏" : "更多" }}
              </el-button>
            </div>
          </div>
          <div class="search-content">
            <el-row :gutter="20">
              <el-col :sm="4">
                <el-input
                  v-model="listParkingSpaceInfo.conditions.areaNum"
                  placeholder="请输入停车场编号"
                ></el-input>
              </el-col>
              <el-col :sm="2">
                <el-button type="primary" @click="openChooseParkingArea">
                  <i class="el-icon-search"></i>
                  选择
                </el-button>
              </el-col>
              <el-col :sm="4">
                <el-input
                  v-model.trim="listParkingSpaceInfo.num"
                  placeholder="请输入车位编号"
                ></el-input>
              </el-col>
              <el-col :sm="4">
                <el-select
                  v-model="listParkingSpaceInfo.conditions.state"
                  placeholder="请选择车位状态"
                  style="width: 100%"
                >
                  <el-option value="" label="请选择车位状态"></el-option>
                  <el-option value="S" label="待售"></el-option>
                  <el-option value="H" label="待租"></el-option>
                  <el-option value="L" label="租赁中"></el-option>
                </el-select>
              </el-col>
              <el-col :sm="6">
                <el-button type="primary" @click="queryParkingSpaceMethod">
                  <i class="el-icon-search"></i>
                  查询
                </el-button>
                <el-button @click="resetParkingSpaceMethod">
                  <i class="el-icon-refresh"></i>
                  重置
                </el-button>
              </el-col>
            </el-row>

            <el-row
              v-show="listParkingSpaceInfo.moreCondition"
              :gutter="20"
              style="margin-top: 15px"
            >
              <el-col :sm="6">
                <el-input
                  v-model.trim="listParkingSpaceInfo.conditions.psId"
                  placeholder="请输入车位ID"
                ></el-input>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>车位信息</span>
            <div style="float: right">
              <!-- 展示剩余车位数按钮 -->
              <el-button
                type="info"
                size="small"
                @click="showRemainingParkingSpaces"
              >
                <i class="el-icon-info"></i>
                剩余车位数
              </el-button>
              <!-- 导入按钮 -->
              <el-button
                type="success"
                size="small"
                @click="openImportParkingSpaceModal"
              >
                <i class="el-icon-upload2"></i>
                导入
              </el-button>
              <!-- 新增：导出按钮 -->
              <el-button
                type="primary"
                size="small"
                @click="exportWork"
                style="margin-right: 10px"
              >
                <i class="el-icon-download"></i>
                导出
              </el-button>
              <el-button
                type="primary"
                size="small"
                @click="openBatchAddParkingSpaceModal"
              >
                <i class="el-icon-plus"></i>
                批量添加
              </el-button>
              <el-button
                type="primary"
                size="small"
                @click="openAddParkingSpaceModal"
              >
                <i class="el-icon-plus"></i>
                添加
              </el-button>
              <!-- 新增：生成合同按钮 -->
              <el-button
                type="warning"
                size="small"
                @click="openGenerateContractModal()"
              >
                <i class="el-icon-document"></i>
                生成合同
              </el-button>
            </div>
          </div>

          <el-table
            :data="listParkingSpaceInfo.parkingSpaces"
            border
            style="width: 100%"
            v-loading="loading"
            row-key="psId"
          >
            <el-table-column
              prop="areaNum"
              label="停车场"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num"
              label="车位编号"
              align="center"
            ></el-table-column>
            <el-table-column label="车位状态" align="center">
              <template slot-scope="scope">
                {{ viewParkingSpaceState(scope.row.state) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="area"
              label="面积"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="contractId"
              label="合同编号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="leaseStartTime"
              label="租赁开始时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="leaseEndTime"
              label="租赁结束时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              align="center"
            ></el-table-column>
            <el-table-column prop="leaseType" label="租赁方式" align="center">
              <template slot-scope="scope">
                {{ viewLeaseType(scope.row.leaseType) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="lesseeName"
              label="承租方"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="parkingSpaceCount"
              label="车位数"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="carNumber"
              label="车牌号"
              align="center"
            ></el-table-column>
            <el-table-column label="总费用" align="center">
              <template slot-scope="scope">
                {{ chineseToNumber(scope.row.totalFeeCn) || 0 }}
              </template>
            </el-table-column>

            <!-- 新增：是否开具印花税 -->
            <el-table-column label="是否开具印花税" align="center" width="200">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.stampDutyStatus"
                  active-value="1"
                  inactive-value="0"
                  active-text="已开具"
                  inactive-text="未开具"
                  @change="handleStampDutyChange(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="280">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    size="mini"
                    type="primary"
                    @click="openEditParkingSpaceModel(scope.row)"
                  >
                    修改
                  </el-button>
                  <el-button
                    size="mini"
                    type="danger"
                    @click="openDelParkingSpaceModel(scope.row)"
                  >
                    删除
                  </el-button>
                  <!-- 新增：修改合同按钮 -->
                  <el-button
                    size="mini"
                    type="warning"
                    @click="openEditContractModal(scope.row)"
                    v-if="scope.row.contractId"
                  >
                    修改合同
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :current-page="listParkingSpaceInfo.currentPage"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listParkingSpaceInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listParkingSpaceInfo.total"
            style="margin-top: 20px; text-align: right"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!-- 导入停车位弹窗 -->
    <el-dialog
      title="导入停车位"
      :visible.sync="importModalVisible"
      width="500px"
      :close-on-click-modal="false"
      @close="handleImportClose"
    >
      <el-form
        ref="importForm"
        :model="importForm"
        :rules="importRules"
        label-width="120px"
        label-position="right"
        class="text-left"
      >
        <el-form-item label="所属停车场" prop="paId">
          <el-select
            v-model="importForm.paId"
            placeholder="请选择所属停车场"
            style="width: 100%"
            @change="handleParkingAreaChange"
          >
            <el-option
              v-for="item in parkingAreaList"
              :key="item.paId"
              :label="item.num"
              :value="item.paId"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="选择文件" prop="file">
          <el-upload
            ref="importUpload"
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :on-exceed="handleFileExceed"
            :file-list="importFileList"
            accept=".xls,.xlsx"
            action=""
            :before-upload="beforeImportUpload"
            :on-remove="handleFileRemove"
          >
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">
              {{
                importFileList.length > 0
                  ? importFileList[0].name
                  : "请上传.xlsx/.xls格式文件，大小不超过10MB（仅支持单个文件）"
              }}
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="下载模板">
          <div>
            请按照模板格式填写数据后导入
            <el-link type="primary" :href="templateUrl" target="_blank">
              下载导入模板
            </el-link>
          </div>
        </el-form-item>

        <el-form-item label="字段说明">
          <el-button type="text" @click="openTemplateDescModal">
            查看字段填写说明
          </el-button>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="importModalVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submitImport"
          :loading="importLoading"
        >
          确认导入
        </el-button>
      </div>
    </el-dialog>

    <!-- 模板字段说明弹窗 -->
    <el-dialog
      title="导入模板字段填写说明"
      :visible.sync="templateDescModalVisible"
      width="600px"
    >
      <el-table :data="templateFieldDesc" border style="width: 100%">
        <el-table-column
          prop="fieldName"
          label="字段名称"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="fieldDesc"
          label="填写说明"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="example"
          label="示例"
          align="center"
          width="200"
        ></el-table-column>
      </el-table>
    </el-dialog>

    <!-- 生成/编辑合同弹窗 -->
    <el-dialog
      :title="isEditContract ? '编辑车位租赁合同' : '生成车位租赁合同'"
      :visible.sync="generateContractModalVisible"
      width="700px"
      :close-on-click-modal="false"
      @close="handleGenerateContractClose"
    >
      <el-form
        ref="generateContractForm"
        :model="generateContractForm"
        :rules="generateContractRules"
        label-width="120px"
        label-position="right"
        class="text-left"
      >
        <el-form-item label="合同ID" v-if="isEditContract">
          <el-input
            v-model="generateContractForm.contractId"
            disabled
            placeholder="系统自动生成"
          ></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="承租方名称" prop="lesseeName">
              <el-input
                v-model.trim="generateContractForm.lesseeName"
                placeholder="请输入承租方名称"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model.trim="generateContractForm.contactPerson"
                placeholder="请输入联系人姓名"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="联系电话" prop="contactPhone">
              <el-input
                v-model.trim="generateContractForm.contactPhone"
                placeholder="请输入联系电话"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="车牌号" prop="carNumber">
              <el-input
                v-model.trim="generateContractForm.carNumber"
                placeholder="请输入车牌号"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="车辆型号及颜色" prop="carModelColor">
              <el-input
                v-model.trim="generateContractForm.carModelColor"
                placeholder="例：宝马3系 白色"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="租赁方式" prop="leaseType">
              <el-select
                v-model="generateContractForm.leaseType"
                placeholder="请选择租赁方式"
                style="width: 100%"
              >
                <el-option label="月租" value="moom"></el-option>
                <el-option label="季度租" value="quarter"></el-option>
                <el-option label="半年租" value="halfYear"></el-option>
                <el-option label="年租" value="year"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="租赁开始时间" prop="leaseStartTime">
              <el-date-picker
                v-model="generateContractForm.leaseStartTime"
                type="date"
                placeholder="选择租赁开始时间"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="租赁结束时间" prop="leaseEndTime">
              <el-date-picker
                v-model="generateContractForm.leaseEndTime"
                type="date"
                placeholder="选择租赁结束时间"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="车位数" prop="parkingSpaceCount">
              <el-input
                v-model.number="generateContractForm.parkingSpaceCount"
                placeholder="请输入租赁车位数量"
                type="number"
                min="1"
                step="1"
                :disabled="isEditContract"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="总费用（大写）" prop="totalFeeCn">
              <el-input
                v-model.trim="generateContractForm.totalFeeCn"
                placeholder="例：壹仟玖佰贰拾元整"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="车位类型" prop="parkingType">
              <el-select
                v-model="generateContractForm.parkingType"
                placeholder="请选择车位类型"
                style="width: 100%"
              >
                <el-option label="地下车位" value="underground"></el-option>
                <el-option label="地上车位" value="ground"></el-option>
                <el-option label="机械车位" value="mechanical"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="12">
            <el-form-item label="邮寄地址" prop="mailingAddress">
              <el-input
                v-model.trim="generateContractForm.mailingAddress"
                placeholder="请输入邮寄地址（非必填）"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :sm="12">
            <el-form-item label="电子邮箱" prop="email">
              <el-input
                v-model.trim="generateContractForm.email"
                placeholder="请输入电子邮箱（非必填）"
                maxlength="100"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="12">
            <el-form-item label="是否开票" prop="needInvoice">
              <el-select
                v-model="generateContractForm.needInvoice"
                placeholder="请选择是否需要开票"
                style="width: 100%"
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="generateContractModalVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="submitContractForm"
          :loading="generateContractLoading"
        >
          {{ isEditContract ? "保存修改" : "生成并下载合同" }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 显示剩余车位数的弹窗 -->
    <el-dialog
      title="停车场剩余车位统计"
      :visible.sync="remainingSpacesVisible"
      width="600px"
    >
      <el-table :data="remainingSpacesData" border style="width: 100%">
        <el-table-column
          prop="areaNum"
          label="停车场编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="totalSpaces"
          label="总车位数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="availableSpaces"
          label="可用车位数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="usedSpaces"
          label="已用车位数"
          align="center"
        ></el-table-column>
        <el-table-column prop="occupancyRate" label="占用率" align="center">
          <template slot-scope="scope">
            {{ scope.row.occupancyRate }}%
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <add-parking-space ref="addParkingSpace" @success="handleAddSuccess" />
    <edit-parking-space ref="editParkingSpace" @success="handleEditSuccess" />
    <delete-parking-space
      ref="deleteParkingSpace"
      @success="handleDeleteSuccess"
    />
    <choose-parking-area
      ref="chooseParkingArea"
      @choose="handleChooseParkingArea"
    />
    <batch-add-parking-space
      ref="batchAddParkingSpace"
      @success="handleBatchAddSuccess"
    />
  </div>
</template>

<script>
import {
  listParkingSpaces,
  importParkingSpaceExcel,
  listParkingAreas,
  generateParkingSpaceContract,
  ListParkingContractInfo,
  EditParkingContract,
  exportParkingSpaceData,
} from "@/api/car/listParkingSpaceApi";
import { getCommunityId } from "@/api/community/communityApi";
import AddParkingSpace from "@/components/car/addParkingSpace";
import EditParkingSpace from "@/components/car/editParkingSpace";
import DeleteParkingSpace from "@/components/car/deleteParkingSpace";
import ChooseParkingArea from "@/components/car/chooseParkingArea";
import BatchAddParkingSpace from "@/components/car/batchAddParkingSpace";
export default {
  name: "ListParkingSpace",
  components: {
    AddParkingSpace,
    EditParkingSpace,
    DeleteParkingSpace,
    ChooseParkingArea,
    BatchAddParkingSpace,
  },
  data() {
    return {
      loading: false,
      importModalVisible: false,
      importLoading: false,
      importFileList: [],

      uploadFile: null,
      templateUrl: "/import/parkingSpace.xlsx",
      importForm: {
        communityId: "",
        paId: "",
      },
      importRules: {
        paId: [
          { required: true, message: "请选择所属停车场", trigger: "blur" },
        ],
        file: [
          {
            required: true,
            message: "请选择要导入的Excel文件",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.importFileList.length === 0) {
                callback(new Error("请选择要导入的Excel文件"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      parkingAreaList: [],
      templateDescModalVisible: false,
      templateFieldDesc: [
        {
          fieldName: "车位编号",
          fieldDesc: "必填，唯一标识车位的编号",
          example: "A101",
        },
        {
          fieldName: "面积",
          fieldDesc: "必填，车位面积（单位：平方米）",
          example: "12.5",
        },
        {
          fieldName: "用户ID",
          fieldDesc: "必填，承租方用户ID（系统内用户ID）",
          example: "302025072717410029",
        },
        {
          fieldName: "停车场ID",
          fieldDesc: "必填，所属停车场ID（需与选择的停车场匹配）",
          example: "102025072745280023",
        },
        {
          fieldName: "承租方名称",
          fieldDesc: "必填，乙方公司名称或个人姓名（合同中乙方名称）",
          example: "长春XX科技有限公司",
        },
        {
          fieldName: "联系人",
          fieldDesc: "必填，承租方联系人姓名（合同中乙方联系人）",
          example: "张三",
        },
        {
          fieldName: "联系电话",
          fieldDesc: "必填，联系人手机号码（合同中乙方联系电话）",
          example: "13800138000",
        },
        {
          fieldName: "车牌号",
          fieldDesc: "必填，租赁车辆的车牌号（合同中车牌号）",
          example: "吉A12345",
        },
        {
          fieldName: "车辆型号及颜色",
          fieldDesc: "必填，车辆型号和颜色（合同中车辆型号及颜色）",
          example: "宝马3系 白色",
        },
        {
          fieldName: "租赁方式",
          fieldDesc:
            "必填，可选值：quarter（季度租）、halfYear（半年租）、year（年租）",
          example: "year",
        },
        {
          fieldName: "租赁开始时间",
          fieldDesc: "必填，格式：yyyy-MM-dd",
          example: "2026-03-01",
        },
        {
          fieldName: "租赁结束时间",
          fieldDesc: "必填，格式：yyyy-MM-dd",
          example: "2027-03-01",
        },
        {
          fieldName: "车位数",
          fieldDesc: "必填，租赁的车位数量",
          example: "1",
        },
        {
          fieldName: "总费用（大写）",
          fieldDesc: "可选，租赁总费用（中文大写）",
          example: "壹仟玖佰贰拾元整",
        },
        {
          fieldName: "邮寄地址",
          fieldDesc: "可选，乙方联系地址",
          example: "吉林省长春市宽城区XX路XX号",
        },
        {
          fieldName: "电子邮箱",
          fieldDesc: "可选，乙方电子邮箱",
          example: "xxx@xxx.com",
        },
      ],
      listParkingSpaceInfo: {
        parkingSpaces: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        num: "",
        moreCondition: false,
        conditions: {
          psId: "",
          area: "",
          paId: "",
          areaNum: "",
          state: "",
        },
      },
      generateContractModalVisible: false,
      generateContractLoading: false,
      isEditContract: false,
      currentParkingSpace: null,
      generateContractForm: {
        contractId: "",
        lesseeName: "",
        contactPerson: "",
        contactPhone: "",
        carNumber: "",
        carModelColor: "",
        leaseType: "",
        leaseStartTime: "",
        leaseEndTime: "",
        parkingSpaceCount: 1,
        totalFeeCn: "",
        parkingType: "",
        mailingAddress: "",
        email: "",
        communityId: "",
        psId: "",
        needInvoice: "",
      },
      generateContractRules: {
        lesseeName: [
          { required: true, message: "请输入承租方名称", trigger: "blur" },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        contactPhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const phoneReg = /^1[3-9]\d{9}$/;
              const telReg = /^0\d{2,3}-\d{7,8}$/;
              if (!phoneReg.test(value) && !telReg.test(value)) {
                callback(new Error("请输入正确的手机号或固定电话"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        needInvoice: [
          { required: true, message: "请选择是否需要开票", trigger: "change" },
        ],
        carNumber: [
          { required: true, message: "请输入车牌号", trigger: "blur" },
        ],
        carModelColor: [
          { required: true, message: "请输入车辆型号及颜色", trigger: "blur" },
        ],
        leaseType: [
          { required: true, message: "请选择租赁方式", trigger: "change" },
        ],
        leaseStartTime: [
          { required: true, message: "请选择租赁开始时间", trigger: "change" },
        ],
        leaseEndTime: [
          { required: true, message: "请选择租赁结束时间", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (this.generateContractForm.leaseStartTime && value) {
                if (
                  new Date(value) <=
                  new Date(this.generateContractForm.leaseStartTime)
                ) {
                  callback(new Error("结束时间必须晚于开始时间"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        parkingSpaceCount: [
          { required: true, message: "请输入车位数", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value < 1) {
                callback(new Error("车位数必须大于等于1"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        totalFeeCn: [
          { required: true, message: "请输入总费用（大写）", trigger: "blur" },
          {
            pattern:
              /^(零|壹|贰|叁|肆|伍|陆|柒|捌|玖|拾|佰|仟|万|亿|元|角|分|整)+$/,
            message: "请输入合法的中文大写金额（如：壹仟玖佰贰拾元整）",
            trigger: "blur",
          },
        ],
        parkingType: [
          { required: true, message: "请选择车位类型", trigger: "change" },
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !/^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)
              ) {
                callback(new Error("请输入正确的邮箱格式"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      remainingSpacesVisible: false,
      remainingSpacesData: [],
    };
  },
  created() {
    this.importForm.communityId = getCommunityId();
    this.generateContractForm.communityId = getCommunityId();
    this.loadParkingSpaceData();
    this.loadParkingAreaList();
  },
  methods: {
    async loadParkingSpaceData() {
      try {
        this.loading = true;
        const params = {
          page: this.listParkingSpaceInfo.currentPage,
          row: this.listParkingSpaceInfo.pageSize,
          communityId: getCommunityId(),
          num: this.listParkingSpaceInfo.num,
          psId: this.listParkingSpaceInfo.conditions.psId,
          area: this.listParkingSpaceInfo.conditions.area,
          paId: this.listParkingSpaceInfo.conditions.paId,
          state: this.listParkingSpaceInfo.conditions.state,
        };

        const res = await listParkingSpaces(params);
        this.listParkingSpaceInfo.parkingSpaces = res.parkingSpaces || [];
        this.listParkingSpaceInfo.total = res.total || 0;
      } catch (error) {
        this.$message.error(error.message || "数据加载失败");
      } finally {
        this.loading = false;
      }
    },

    async loadParkingAreaList() {
      try {
        const res = await listParkingAreas({
          communityId: getCommunityId(),
          page: 1,
          row: 100,
        });
        this.parkingAreaList = res.parkingAreas || [];
      } catch (error) {
        console.error("加载停车场列表失败:", error);
        this.$message.error("加载停车场列表失败");
      }
    },

    viewParkingSpaceState(state) {
      const stateMap = {
        S: "待售",
        H: "待租",
        L: "租赁中",
      };
      return stateMap[state] || "未知";
    },

    toggleMoreCondition() {
      this.listParkingSpaceInfo.moreCondition =
        !this.listParkingSpaceInfo.moreCondition;
    },

    queryParkingSpaceMethod() {
      this.listParkingSpaceInfo.currentPage = 1;
      this.loadParkingSpaceData();
    },

    resetParkingSpaceMethod() {
      this.listParkingSpaceInfo.conditions = {
        psId: "",
        area: "",
        paId: "",
        areaNum: "",
        state: "",
      };
      this.listParkingSpaceInfo.num = "";
      this.queryParkingSpaceMethod();
    },

    openChooseParkingArea() {
      this.$refs.chooseParkingArea.open();
    },

    openAddParkingSpaceModal() {
      this.$refs.addParkingSpace.open();
    },

    openEditParkingSpaceModel(row) {
      this.$refs.editParkingSpace.open(row);
    },

    openDelParkingSpaceModel(row) {
      this.$refs.deleteParkingSpace.open(row);
    },

    openBatchAddParkingSpaceModal() {
      this.$refs.batchAddParkingSpace.open();
    },

    async showRemainingParkingSpaces() {
      try {
        this.remainingSpacesVisible = true;

        const parkingAreasRes = await listParkingAreas({
          communityId: getCommunityId(),
          page: 1,
          row: 100,
        });
        const parkingAreas = parkingAreasRes.parkingAreas || [];

        const allParkingSpacesRes = await listParkingSpaces({
          communityId: getCommunityId(),
          page: 1,
          row: 10000,
        });
        const allParkingSpaces = allParkingSpacesRes.parkingSpaces || [];

        const statistics = parkingAreas.map((area) => {
          const spacesInArea = allParkingSpaces.filter(
            (space) => space.paId === area.paId,
          );
          const totalSpaces = spacesInArea.length;
          const usedSpaces = spacesInArea.filter(
            (space) => space.state === "L",
          ).length;
          const availableSpaces = totalSpaces - usedSpaces;
          const occupancyRate =
            totalSpaces > 0 ? Math.round((usedSpaces / totalSpaces) * 100) : 0;

          return {
            areaNum: area.num,
            totalSpaces,
            availableSpaces,
            usedSpaces,
            occupancyRate,
          };
        });

        this.remainingSpacesData = statistics;
      } catch (error) {
        console.error("获取剩余车位数失败:", error);
        this.$message.error("获取剩余车位数失败");
      }
    },

    async openImportParkingSpaceModal() {
      this.importModalVisible = true;
      this.importFileList = [];
      this.importLoading = false;
      this.uploadFile = null;
      this.$nextTick(() => {
        if (this.$refs.importForm) {
          this.$refs.importForm.resetFields();
        }
        if (this.$refs.importUpload) {
          this.$refs.importUpload.clearFiles();
        }
      });
      await this.loadParkingAreaList();
    },

    handleImportClose() {
      this.importFileList = [];
      this.uploadFile = null;
      if (this.$refs.importForm) {
        this.$refs.importForm.resetFields();
      }
    },
    chineseToNumber(chinese) {
      if (!chinese) return 0;
      const numMap = {
        零: 0,
        壹: 1,
        贰: 2,
        叁: 3,
        肆: 4,
        伍: 5,
        陆: 6,
        柒: 7,
        捌: 8,
        玖: 9,
      };
      const unitMap = {
        拾: 10,
        佰: 100,
        仟: 1000,
        万: 10000,
        亿: 100000000,
      };

      let result = 0;
      let temp = 0;
      let unit = 1;

      for (let i = chinese.length - 1; i >= 0; i--) {
        const char = chinese[i];
        if (numMap[char] !== undefined) {
          temp = numMap[char] * unit;
          result += temp;
        } else if (unitMap[char]) {
          unit = unitMap[char];
        }
      }
      return result;
    },

    handleParkingAreaChange() {},

    openTemplateDescModal() {
      this.templateDescModalVisible = true;
    },

    beforeImportUpload(file) {
      const isExcel = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isExcel) {
        this.$message.error("请上传Excel格式文件（.xlsx/.xls）");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过10MB");
        return false;
      }
      return true;
    },

    handleFileExceed(files, fileList) {
      this.$message.warning(
        `仅支持上传1个文件，已自动忽略多余的${files.length}个文件`,
      );
      this.importFileList = [fileList[0]];
      this.uploadFile = fileList[0].raw;
    },

    handleFileChange(file, fileList) {
      if (fileList.length > 1) {
        fileList = [fileList[fileList.length - 1]];
      }
      this.importFileList = fileList;
      if (fileList.length > 0) {
        this.uploadFile = file.raw;
        this.$nextTick(() => {
          this.$refs.importForm.validateField("file");
        });
      } else {
        this.uploadFile = null;
      }
    },

    handleFileRemove(file, fileList) {
      this.importFileList = fileList;
      this.uploadFile = fileList.length > 0 ? fileList[0].raw : null;
      this.$refs.importForm.validateField("file");
    },

    downloadContractFile(
      contractBase64,
      fileName = "长新创谷地下车库租赁协议书.docx",
    ) {
      try {
        if (!contractBase64) {
          this.$message.error("合同数据无效");
          return;
        }

        const byteCharacters = atob(contractBase64);
        const byteNumbers = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([byteNumbers], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        this.$message.success("合同下载成功");
      } catch (error) {
        this.$message.error("合同下载失败");
        console.error("合同下载失败：", error);
      }
    },

    async submitImport() {
      try {
        const valid = await new Promise((resolve) => {
          this.$refs.importForm.validate((valid) => {
            resolve(valid);
          });
        });

        if (!valid) {
          this.$message.warning("请完善必填项后再提交");
          return;
        }

        if (!this.uploadFile || this.importFileList.length === 0) {
          this.$message.error("请选择有效的Excel文件后再导入");
          return;
        }

        this.importLoading = true;

        const formData = new FormData();
        formData.append("uploadFile", this.uploadFile);
        formData.append("communityId", this.importForm.communityId);
        formData.append("paId", this.importForm.paId);
        formData.append("importAdapt", "importParkingSpace");

        const res = await importParkingSpaceExcel(formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (res.code === 0) {
          this.$message.success("导入成功");
          if (res.contractBase64) {
            this.downloadContractFile(res.contractBase64);
          }
          this.importModalVisible = false;
          await this.loadParkingSpaceData();
        } else {
          this.$message.error(res.msg || "导入失败");
        }
      } catch (error) {
        this.$message.error(error.message || "导入失败");
        console.error("导入失败:", error);
      } finally {
        this.importLoading = false;
      }
    },

    openGenerateContractModal(row = null) {
      this.isEditContract = false;
      this.currentParkingSpace = row;
      this.generateContractModalVisible = true;
      this.$nextTick(() => {
        if (this.$refs.generateContractForm) {
          this.$refs.generateContractForm.resetFields();
        }
        this.generateContractForm = {
          contractId: "",
          lesseeName: "",
          contactPerson: "",
          contactPhone: "",
          carNumber: "",
          carModelColor: "",
          leaseType: "",
          leaseStartTime: "",
          leaseEndTime: "",
          parkingSpaceCount: 1,
          totalFeeCn: "",
          parkingType: "",
          mailingAddress: "",
          email: "",
          communityId: getCommunityId(),
          psId: row ? row.psId : "",
          needInvoice: "",
        };
      });
    },

    async openEditContractModal(row) {
      try {
        this.currentParkingSpace = row;
        const res = await ListParkingContractInfo({
          parkingSpaceId: row.psId,
          communityId: getCommunityId(),
        });
        if (res.code !== 0 || !res.data) {
          this.$message.error(res.msg || "查询合同详情失败");
          return;
        }

        this.isEditContract = true;
        this.generateContractModalVisible = true;
        this.$nextTick(() => {
          if (this.$refs.generateContractForm) {
            this.$refs.generateContractForm.resetFields();
          }
          this.generateContractForm = {
            ...res.data,
            needInvoice: res.data.needInvoice + "",
            communityId: getCommunityId(),
            psId: row.psId,
          };
        });
      } catch (error) {
        this.$message.error(error.message || "查询合同详情失败");
        console.error("查询合同详情失败:", error);
      }
    },

    handleGenerateContractClose() {
      this.generateContractLoading = false;
      this.isEditContract = false;
      this.currentParkingSpace = null;
      if (this.$refs.generateContractForm) {
        this.$refs.generateContractForm.resetFields();
      }
    },

    async submitContractForm() {
      try {
        const valid = await new Promise((resolve) => {
          this.$refs.generateContractForm.validate((valid) => {
            resolve(valid);
          });
        });

        if (!valid) {
          this.$message.warning("请完善必填项并修正错误格式");
          return;
        }

        this.generateContractLoading = true;

        let res;
        if (this.isEditContract) {
          res = await EditParkingContract(this.generateContractForm);
          if (res.code === 0) {
            this.$message.success("合同修改成功！");
            this.generateContractModalVisible = false;
            this.loadParkingSpaceData();
          } else {
            this.$message.error(res.msg || "合同修改失败");
          }
        } else {
          res = await generateParkingSpaceContract(this.generateContractForm);
          if (res.code === 0 && res.data) {
            this.downloadContractFile(res.data);
            this.generateContractModalVisible = false;
            this.$message.success("合同生成成功！");
            this.loadParkingSpaceData();
          } else {
            this.$message.error(res.msg || "合同生成失败");
          }
        }
      } catch (error) {
        this.$message.error(
          error.message ||
            (this.isEditContract ? "合同修改失败" : "合同生成失败"),
        );
        console.error(
          this.isEditContract ? "修改合同失败:" : "生成合同失败:",
          error,
        );
      } finally {
        this.generateContractLoading = false;
      }
    },

    // ========== 印花税开关（调用 EditParkingContract） ==========
    async handleStampDutyChange(row) {
      const text = row.stampDutyStatus === "1" ? "开具" : "取消开具";

      try {
        await this.$confirm(`是否确认${text}该车位印花税？`, "提示", {
          type: "warning",
        });

        // 调用 EditParkingContract，仅传 psId + stampDutyStatus
        const res = await EditParkingContract({
          contractId: row.contractId,
          parkingSpaceId: row.psId,
          stampDutyStatus: row.stampDutyStatus,
        });

        if (res.code === 0) {
          this.$message.success(`${text}成功`);
        } else {
          row.stampDutyStatus = row.stampDutyStatus === "1" ? "0" : "1";
          this.$message.error(res.msg || `${text}失败`);
        }
      } catch (e) {
        row.stampDutyStatus = row.stampDutyStatus === "1" ? "0" : "1";
        this.$message.info("已取消操作");
      }
    },

    async exportWork() {
      try {
        const useCommunityId = getCommunityId();

        const params = {
          pagePath: "listParkingSpace",
          communityId: useCommunityId,
          page: undefined,
          row: undefined,
        };

        await exportParkingSpaceData(params);

        this.$message.success("导出成功，请到下载中心查看");
        this.$router.push("/pages/property/downloadTempFile?tab=下载中心");
      } catch (error) {
        console.error("导出失败:", error);
        this.$message.error("导出失败，请稍后重试");
      }
    },

    handleChooseParkingArea(parkingArea) {
      this.listParkingSpaceInfo.conditions.paId = parkingArea.paId;
      this.listParkingSpaceInfo.conditions.areaNum = parkingArea.num;
    },

    handleAddSuccess() {
      this.loadParkingSpaceData();
    },

    handleEditSuccess() {
      this.loadParkingSpaceData();
    },

    handleDeleteSuccess() {
      this.loadParkingSpaceData();
    },

    handleBatchAddSuccess() {
      this.loadParkingSpaceData();
    },

    handlePageChange(page) {
      this.listParkingSpaceInfo.currentPage = page;
      this.loadParkingSpaceData();
    },

    handleSizeChange(size) {
      this.listParkingSpaceInfo.pageSize = size;
      this.loadParkingSpaceData();
    },

    // 租赁方式 文字映射
    viewLeaseType(type) {
      const typeMap = {
        moom: "月租", // 你代码里写的是 moom（月）
        quarter: "季度租",
        halfYear: "半年租",
        year: "年租",
      };
      return typeMap[type] || "";
    },
  },
};
</script>

<style scoped>
.parking-space-container {
  padding: 20px;
}

.search-content {
  padding: 10px 0;
}

.ibox-tools {
  display: inline-block;
  float: right;
  margin-top: 0;
  position: relative;
  padding: 0;
}

.el-input-group {
  display: flex;
}

.text-left {
  text-align: left;
}

.upload-demo {
  margin: 20px 0;
  text-align: center;
}

.dialog-footer {
  text-align: right;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
}
::v-deep .el-table td {
  vertical-align: middle;
}

::v-deep .el-table .available-spaces {
  color: green;
  font-weight: bold;
}

::v-deep .el-table .used-spaces {
  color: red;
  font-weight: bold;
}
</style>
